var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-page"},[_c('div',{staticClass:"home-page__search"},[_c('div',{staticClass:"home-page__search-container"},[_c('h1',{staticClass:"m-0 home-page__title"},[_vm._v("How can I help?")]),_c(_setup.Search)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }